<template>
    <span class="radio-wrapper">
        <div class="form-check" v-for="option in field.options" :key="option.id">
            <input
                type="radio"
                class="form-check-input"
                :name="field.name"
                :id="option.id"
                :value="option.value"
                @change="$emit('filled-out', $event.target.value)"
            >
            <label :for="option.id">{{option.label}}</label>
        </div>
    </span>
</template>

<script>
  export default {
    props: {
      field: {},
    },
  };
</script>
